import { addTask } from "../utils/bugFixer";
import { Action, Reducer } from "redux";
import * as Api from "../api/api";
import Moment from "moment";
import * as MultiPortStore from './MultiPort';
import { AppThunkAction } from "./";
import { getDefaultHeaders } from "../utils/utils";
import Notifications from "react-notification-system-redux";
import { getText } from "../utils/langTexts";



export interface UserState {
    isLoading: boolean;
    requestTime?: number;
    entities: Array<Api.UserManagementModel>;
    isLoadingStructure: boolean;
    requestTimeStructure?: number;
    firmStructure: Array<Api.FirmModel>;
    selectedId?: number;
    selectedFirms: Api.SubscriptionsManagemenet[];
/*    userRegister: Api.UserRegisterModel,*/
    createState: {
        isLoading: boolean;
        requestTime?: number;
    };
    updateState: {
        [id: number]: {
            isLoading: boolean;
            requestTime?: number;
        }
    },
    filter: {
        companyId?: number;
        agencyId?: number;
        email?: string;
        onlyActive?: boolean;
    }
}



interface UpdateFilterCompanyId { type: "UPDATE_FILTER_COMPANYID"; payload: { value: number }; error?: any;}
interface UpdateFilterAgencyId { type: "UPDATE_FILTER_AGENCYID"; payload: { value: number }; error?: any;}
interface UpdateFilterEmail { type: "UPDATE_FILTER_EMAIL"; payload: { value: string }; error?: any;}
interface UpdateFilterOnlyActive { type: "UPDATE_FILTER_ONLYACTIVE"; payload: { value: boolean }; error?: any;}
interface RequestUserEntitties { type: "REQUEST_USER_ENTITIES"; payload: { requestTime: number }; }

interface ReceiveUserEntitties { type: "RECEIVE_USER_ENTITIES"; payload: { requestTime: number; entities?: Array<Api.UserManagementModel> }; error?: any;}
interface RequestUserEntitties { type: "REQUEST_USER_ENTITIES"; payload: { requestTime: number }; }


interface ReceiveUserFirmStructrure { type: "RECEIVE_USER_FIRM_STRUCTURE"; payload: { requestTimeStructure: number; firmStructure?: Array<Api.FirmModel> }; error?: any; }
interface RequestFirmStructrure { type: "REQUEST_USER_FIRM_STRUCTURE"; payload: { requestTimeStructure: number }; }


interface RequestUserDeactivate {   type: "REQUEST_USER_DEACTIVATE";    payload: { requestTime: number; id: number; };}
interface ReceiveUserDeactivate { type: "RECEIVE_USER_DEACTIVATE"; payload: { requestTime: number; id: number; entity?: Api.UserManagementModel }; error?: any; }

interface RequestCarrierRatesSettingsCreate {
    type: "REQUEST_USER_CREATE";
    payload: { requestTime: number };
}
interface ReceiveCarrierRatesSettingsCreate {
    type: "RECEIVE_USER_CREATE";
    payload: { requestTime: number; entity?: Api.UserManagementModel };
    error?: any;
}

interface RequestCarrierRatesSettingsUpdate {
    type: "REQUEST_USER_UPDATE";
    payload: { requestTime: number; id: number; };
}
interface ReceiveCarrierRatesSettingsUpdate {
    type: "RECEIVE_USER_UPDATE";
    payload: { requestTime: number; id: number; entity?: Api.UserManagementModel };
    error?: any;
}

interface UpdateFirmSelected {
    type: "UPDATE_FIRM_SELECTED"; payload: { firmId: number; value: boolean }; 
}

interface UpdateUserSelectedId {
    type: "UPDATE_USER_SELECTEDID";
    payload: { value: number; };
}

export type KnownAction = ReceiveUserEntitties | RequestUserEntitties |
    RequestUserDeactivate | ReceiveUserDeactivate | RequestCarrierRatesSettingsCreate | ReceiveCarrierRatesSettingsCreate
    | RequestCarrierRatesSettingsUpdate | ReceiveCarrierRatesSettingsUpdate | UpdateFirmSelected | UpdateUserSelectedId | RequestFirmStructrure | ReceiveUserFirmStructrure
    | UpdateFilterEmail
    | UpdateFilterCompanyId
    | UpdateFilterAgencyId
    | UpdateFilterOnlyActive
    ;


export const actionCreators = {

    updateFirmSelected: (firmId: number, value: boolean) => <UpdateFirmSelected>{
        type: 'UPDATE_FIRM_SELECTED', payload: { firmId: firmId, value: value }
    },
    updateUserSelectedId: (id: number) => <UpdateUserSelectedId>{
        type: "UPDATE_USER_SELECTEDID",
        payload: { value: id }
    },
    requestUsers: (requestTime: number): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.UsersApi();
        let fetch = api.getEntities({ credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entities => {
                dispatch({
                    type: "RECEIVE_USER_ENTITIES",
                    payload: { requestTime: requestTime, entities: entities }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_USER_ENTITIES",
                    payload: { requestTime: requestTime, },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_USER_ENTITIES",
            payload: { requestTime: requestTime }
        });
        addTask(fetch);
        return fetch;
    },
    requestFirmStructure: (requestTime: number): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.UsersApi();
        let fetch = api.getFirmStructure({ credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(firms => {
                dispatch({
                    type: "RECEIVE_USER_FIRM_STRUCTURE",
                    payload: { requestTimeStructure: requestTime, firmStructure: firms }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_USER_FIRM_STRUCTURE",
                    payload: { requestTimeStructure: requestTime, },
                    error: err
                });
            });
        dispatch({
            type: "REQUEST_USER_FIRM_STRUCTURE",
            payload: { requestTimeStructure: requestTime }
        });
        addTask(fetch);
        return fetch;
    },

    requestResetUser: (requestTime: number, id: number): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.UsersApi();
        let fetch = api.disable({ id: id }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_USER_DEACTIVATE",
                    payload: { requestTime: requestTime, id: id, entity: entity }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_USER_DEACTIVATE",
                    payload: { requestTime: requestTime, id: id },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_USER_DEACTIVATE",
            payload: { requestTime: requestTime, id: id }
        });
        return fetch;
    },
    requestDeactivateUser: (requestTime: number, id: number): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.UsersApi();
        let fetch = api.disable({ id: id }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_USER_DEACTIVATE",
                    payload: { requestTime: requestTime, id: id, entity : entity }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_USER_DEACTIVATE",
                    payload: { requestTime: requestTime, id: id },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_USER_DEACTIVATE",
            payload: { requestTime: requestTime, id: id }
        });
        return fetch;
    },
    requestCreateUser: (requestTime: number, model: Api.UserManagementModel): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.UsersApi();
        let fetch = api.create({ model: model }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_USER_CREATE",
                    payload: { requestTime: requestTime, entity: entity }
                });
                dispatch(Notifications.success({ message:"User created!", title: getText("GenSuccess"), position: "tc" }) as any);
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_USER_CREATE",
                    payload: { requestTime: requestTime, },
                    error: err
                });
                dispatch(Notifications.error({ message: "User creation failure", title: getText("GenError"), position: "tc" }) as any);
            });

        dispatch({
            type: "REQUEST_USER_CREATE",
            payload: { requestTime: requestTime }
        });
        return fetch;
    },
    requestUpdateUser: (requestTime: number, model: Api.UserManagementModel): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.UsersApi();
        let fetch = api.update({ model: model }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_USER_UPDATE",
                    payload: { requestTime: requestTime, id: model.clientId, entity: entity }
                });
                dispatch(Notifications.success({ message: "User updated!", title: getText("GenSuccess"), position: "tc" }) as any);
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_USER_UPDATE",
                    payload: { requestTime: requestTime, id: model.clientId },
                    error: err
                });
                dispatch(Notifications.error({ message: "User update failure", title: getText("GenError"), position: "tc" }) as any);
            });

        dispatch({
            type: "REQUEST_USER_UPDATE",
            payload: { requestTime: requestTime, id: model.clientId }
        });
        return fetch;
    },
    updateFilterCompanyId: (value?: number) => <UpdateFilterCompanyId>{
        type: 'UPDATE_FILTER_COMPANYID', payload: { value: value }
    },
    updateFilterAgencyId: (value?: number) => <UpdateFilterAgencyId>{
        type: 'UPDATE_FILTER_AGENCYID', payload: { value: value }
    },
    updateFilterEmail: (value?: string) => <UpdateFilterEmail>{
        type: 'UPDATE_FILTER_EMAIL', payload: { value: value }
    },
    updateFilterOnlyActive: (value?: boolean) => <UpdateFilterOnlyActive>{
        type: 'UPDATE_FILTER_ONLYACTIVE', payload: { value: value }
    },
}

const unloadedState: UserState = {
    isLoading: false,
    entities: [],
    selectedFirms: [],
    firmStructure: [],
    updateState: {},
    isLoadingStructure: false,
    createState: {
        isLoading: false
    },
    filter: {
        
    }
};


export const reducer: Reducer<UserState> = (state: UserState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;

    switch (action.type) {
        case "REQUEST_USER_ENTITIES":
            return {
                ...state,
                isLoading: true,
                requestTime: action.payload.requestTime
            };
        case "RECEIVE_USER_ENTITIES":
            if (state.requestTime !== action.payload.requestTime)
                return state;

            return {
                ...state,
                isLoading: false,
                entities: action.error
                    ? state.entities
                    : action.payload.entities
            };

        case "REQUEST_USER_FIRM_STRUCTURE":
            return {
                ...state,
                isLoadingStructure: true,
                requestTimeStructure: action.payload.requestTimeStructure
            };
        case "RECEIVE_USER_FIRM_STRUCTURE":
            if (state.requestTimeStructure !== action.payload.requestTimeStructure)
                return state;
            return {
                ...state,
                isLoadingStructure: false,
                firmStructure: action.error
                    ? state.firmStructure
                    : action.payload.firmStructure
            };

        case "REQUEST_USER_CREATE":
            return {
                ...state,
                createState: {
                    ...state.createState,
                    isLoading: true,
                    requestTime: action.payload.requestTime
                }
            };
        case "RECEIVE_USER_CREATE":
            if (action.payload.requestTime !== state.createState.requestTime)
                return state;

            return {
                ...state,
                createState: {
                    ...state.createState,
                    isLoading: false,
                },
                entities: action.error
                    ? state.entities
                    : state.entities.concat([action.payload.entity])
            };
        case "REQUEST_USER_UPDATE":
            return {
                ...state,
                updateState: {
                    ...state.updateState,
                    [action.payload.id]: {
                        ...state.updateState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                }
            };
        case "RECEIVE_USER_UPDATE":
            if (!state.updateState[action.payload.id]
                || action.payload.requestTime !== state.updateState[action.payload.id].requestTime)
                return state;

            return {
                ...state,
                updateState: {
                    ...state.updateState,
                    [action.payload.id]: {
                        ...state.updateState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                },
                entities: action.error
                    ? state.entities
                    : state.entities.map(x => x.clientId === action.payload.entity.clientId
                        ? { ...x, ...action.payload.entity }
                        : x)
            };
        case "REQUEST_USER_DEACTIVATE":
            return {
                ...state,
                updateState: {
                    ...state.updateState,
                    [action.payload.id]: {
                        ...state.updateState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                }
            };
        case "RECEIVE_USER_DEACTIVATE":       
            if (!state.updateState[action.payload.id]
                || action.payload.requestTime !== state.updateState[action.payload.id].requestTime)
                return state;

            return {
                ...state,
                updateState: {
                    ...state.updateState,
                    [action.payload.id]: {
                        ...state.updateState[action.payload.id],
                        isLoading: false,
                        requestTime: action.payload.requestTime
                    }
                },
                entities: action.error
                    ? state.entities
                    : state.entities.map(x => x.clientId === action.payload.entity.clientId
                        ? {
                            ...x,
                            account: {
                             ...x.account,
                             expirationDate: action.payload.entity.account.expirationDate
                            }
                        }
                        : x),
            };
        case "UPDATE_FIRM_SELECTED":
            var firm = state.selectedFirms.map(x => x.firmId === action.payload.firmId);

            return {
                ...state,
                selectedFirms: state.selectedFirms.map(x => x.firmId === action.payload.firmId
                    ? {
                        ...x,
                        isSelected: action.payload.value
                    }
                    : x),
            };  
        case "UPDATE_USER_SELECTEDID":            
            return {
                ...state,
                selectedId: action.payload.value
            };
        case "UPDATE_FILTER_COMPANYID":
            return {
                ...state,
                filter: {
                    ...state.filter,
                    companyId: action.payload.value,
                    agencyId: null
                }
            };
        case "UPDATE_FILTER_AGENCYID":
            return {
                ...state,
                filter: {
                    ...state.filter,
                    agencyId: action.payload.value
                }
            };
        case "UPDATE_FILTER_EMAIL":
            return {
                ...state,
                filter: {
                    ...state.filter,
                    email: action.payload.value
                }
            };
        case "UPDATE_FILTER_ONLYACTIVE":
            return {
                ...state,
                filter: {
                    ...state.filter,
                    onlyActive: action.payload.value
                }
            };
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state || unloadedState;
};
